import React, { useEffect, useState } from "react";
import styles from "./sideBar.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useAllProduct } from "../../api-context/commonApiContext";

const SideBar = ({ closeSidebar }) => {
  const { role, loggedBy, subescrowSidebar } = useAllProduct();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeButton, setActiveButton] = useState("transaction");
  const [payoutView, setPayoutView] = useState(false);
  const isActive = location.pathname.startsWith("/escrow-management");

  useEffect(() => {
    const path = location.pathname;

    // Set active button
    const routeToButtonMap = {
      "/transaction": "transaction",
      "/payout": "payout",
      "/payout-view": "payout-view",
      "/statement": "statement",
      "/contact": "contact",
      "/report": "report",
      "/beneficiary": "beneficiary",
      "/user-management": "user-management",
      "/sub-escrow": "sub-escrow",
      "/escrow-management": "escrow-management",
    };

    const newActive = routeToButtonMap[path] || "";
    setActiveButton(newActive);

    // Toggle payoutView only for payout-view route
    setPayoutView(path === "/payout-view");
  }, [location.pathname]);

  const handleButtonClick = (buttonId, path) => {
    setActiveButton(buttonId);
    navigate(path);
    // Close sidebar only on mobile/tablet (screen width < 992px)
    if (window.innerWidth < 992 && closeSidebar) {
      closeSidebar();
    }
  };

  console.log("loggedBy", loggedBy);

  return (
    <div className={`${styles.sidenavecontainerParent} h-100 w-100 p-2`}>
      <div className={`d-flex justify-content-center align-items-center`}>
        <img
          className={`${styles.escrowstackLogos27Icon}`}
          alt=""
          src="/escrowLogo.svg"
        />
      </div>
      <div
        className={`${styles.sidenavecontainer} d-flex justify-content-center align-items-center`}
      >
        <b className={styles.getintofintech}>Getintofintech</b>
      </div>
      {(loggedBy === "bank_admin" || loggedBy === "user") && (
        <button
          className={`${styles.transactionsButtons} ${
            isActive ? styles.activeButton : ""
          }`}
          onClick={() =>
            handleButtonClick("escrow-management", "/escrow-management")
          }
        >
          <img
            className={isActive ? styles.arrowDownUpIcon : ""}
            alt=""
            src={isActive ? "/esc-Mgmt-unsel.svg" : "/escMgmt-unsel.svg"}
          />
          <div className={styles.transactions}>Escrow Management</div>
        </button>
      )}
      <button
        className={`${styles.transactionsButtons} ${
          activeButton === "transaction" ? styles.activeButton : ""
        }`}
        onClick={() => handleButtonClick("transaction", "/transaction")}
      >
        <img
          className={
            activeButton === "transaction" ? styles.arrowDownUpIcon : ""
          }
          alt=""
          src={
            activeButton === "transaction"
              ? "/arrowdownup.svg"
              : "/arrow-down-up.svg"
          }
        />
        <div className={styles.transactions}>Transaction</div>
      </button>

      <button
        className={`${styles.statementsButtons} ${
          activeButton === "payout" ? styles.activeButton : ""
        }`}
        onClick={() => handleButtonClick("payout", "/payout")}
      >
        <img
          className={styles.statementsButtonsChild}
          alt=""
          src={
            activeButton === "payout"
              ? "/coins-active.svg"
              : "/coins-stacked-03.svg"
          }
        />
        <div className={styles.statements}>Payout</div>
        <div onClick={() => setPayoutView(!payoutView)}>
          <img
            className={styles.statementsButtonsChild}
            alt=""
            src={payoutView === true ? "/dropdown.svg" : "/payoutInactive.svg"}
          />
        </div>
      </button>
      {payoutView && (
        <div className={`${styles.payoutsub} d-flex `}>
          <button
            className={`${styles.transactionsButtons} ${
              activeButton === "payout-view" ? styles.activeButton : ""
            } w-100`}
            onClick={() => handleButtonClick("payout-view", "/payout-view")}
          >
            <li>Payout View</li>
          </button>
        </div>
      )}
      {/* <button
        className={`${styles.transactionsButtons} ${
          activeButton === "statement" ? styles.activeButton : ""
        }`}
        onClick={() => handleButtonClick("statement", "/statement")}
      >
        <img
          className={styles.arrowDownUpIcon}
          alt=""
          src={activeButton === "statement" ? "Layer_1.svg" : "/Group 2354.svg"}
        />
        <div className={styles.transactions}>Fee statement</div>
      </button> */}
      <button
        className={`${styles.transactionsButtons} ${
          activeButton === "report" ? styles.activeButton : ""
        }`}
        onClick={() => handleButtonClick("report", "/report")}
      >
        <img
          className={styles.arrowDownUpIcon}
          alt=""
          src={activeButton === "report" ? "/Layer_1.svg" : "/Group 2354.svg"}
        />
        <div className={styles.transactions}>Report</div>
      </button>
      <button
        className={`${styles.transactionsButtons} ${
          activeButton === "beneficiary" ? styles.activeButton : ""
        }`}
        onClick={() => handleButtonClick("beneficiary", "/beneficiary")}
      >
        <img
          className={styles.arrowDownUpIcon}
          alt=""
          src={
            activeButton === "beneficiary" ? "/Union.svg" : "/UnionDeselect.svg"
          }
        />
        <div className={styles.transactions}>Beneficiary</div>
      </button>
      <button
        className={`${styles.transactionsButtons} ${
          activeButton === "user-management" ? styles.activeButton : ""
        }`}
        onClick={() => handleButtonClick("user-management", "/user-management")}
      >
        <img
          className={styles.arrowDownUpIcon}
          alt=""
          src={
            activeButton === "user-management"
              ? "/user-management-sel.svg"
              : "/usermgmt-unsel.svg"
          }
        />
        <div className={styles.transactions}>User Management</div>
      </button>
      {loggedBy === "client" && subescrowSidebar && (
        <button
          className={`${styles.transactionsButtons} ${
            activeButton === "sub-escrow" ? styles.activeButton : ""
          }`}
          onClick={() => handleButtonClick("sub-escrow", "/sub-escrow")}
        >
          <img
            className={styles.arrowDownUpIcon}
            alt=""
            src={
              activeButton === "sub-escrow"
                ? "/esc-Mgmt-unsel.svg"
                : "/escMgmt-unsel.svg"
            }
          />
          <div className={styles.transactions}>Sub Escrow</div>
        </button>
      )}
      {/* <button
        className={`${styles.transactionsButtons} ${
          activeButton === "contact" ? styles.activeButton : ""
        }`}
        onClick={() => handleButtonClick("contact", "/contact")}
      >
        <img
          className={styles.arrowDownUpIcon}
          alt=""
          src={activeButton === "contact" ? "Union.svg" : "UnionDeselect.svg"}
        />
        <div className={styles.transactions}>Contact</div>
      </button> */}
    </div>
  );
};

export default SideBar;
